import React from 'react'
import { createUseStyles } from 'react-jss'
import cn from 'classnames'
import theme from '../style/theme'

const AccordionItem = ({ title, content, isOpen, onClick }) => {
  const classes = useStyles()
  return (
    <div className={classes.accordionItem}>
      <button
        className={cn(classes.accordionHeader, { [classes.active]: isOpen })}
        onClick={onClick}
      >
        {title}
        <span className={classes.accordionIcon}>{isOpen ? '−' : '+'}</span>
      </button>
      <div className={cn(classes.accordionContent, { [classes.open]: isOpen })}>
        {content}
      </div>
    </div>
  )
}

const useStyles = createUseStyles({
  accordionItem: {
    borderBottom: `1px solid ${theme.colors.border}`,
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  accordionHeader: {
    width: '100%',
    padding: '9px 0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 400,
    color: theme.colors.primary,
    transition: 'color 0.3s ease',
    '&:hover': {
      color: theme.colors.secondary
    }
  },
  active: {
    color: theme.colors.secondary,
    fontWeight: 400
  },
  accordionIcon: {
    fontSize: '1.5rem',
    lineHeight: 1,
    opacity: 0.5,
    color: theme.colors.primary
  },
  accordionContent: {
    maxHeight: 0,
    overflow: 'hidden',
    transition: 'all 0.3s ease-in-out',
    opacity: 0,
    fontSize: '14px',
    '& p:first-child': {
      marginTop: 0
    },
    '& p:last-child': {
      marginBottom: 0
    }
  },
  open: {
    maxHeight: '500px',
    opacity: 1,
    paddingBottom: '1.5rem'
  }
}, { name: 'AccordionItem' })

export default AccordionItem
